import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const PPT_FILE_ICON_URL = '/static/images/ppt_file_icon.png';

const PresentationProcessing_ViewerVersion1 = ({
  canDownloadAsset,
  downloadLink,
  displayFilename,
  onDownloadClick 
})=> (
  <div className="presentation-wrapper">
    <div className="still-processing">

      <img className="ppt-icon" src={PPT_FILE_ICON_URL} />

      <div className="processing-description">
        Your Presentation is still being processed. Please check back in a few minutes to view it.
      </div>

      {
        (canDownloadAsset && downloadLink !== null) &&
          <Fragment>
            In the meantime you can
            <span
              className="download-link"
              title={displayFilename}
              onClick={onDownloadClick}
            >
              {' download ' /* spaces in React are annoying */}
            </span>
            the file.
          </Fragment>
      }

    </div>
  </div>
);

const PresentationProcessing_ViewerVersion2 = ({
  canDownloadAsset,
  downloadLink,
  displayFilename,
  onDownloadClick 
})=> (
  <div className="presentation-wrapper">
    <div className="still-processing">

      <img
        className="ppt-icon"
        src={PPT_FILE_ICON_URL}
        alt="Presentation icon"
      />

      <div className="processing-description">
        Your Presentation is still being processed. Please check back in a few minutes to view it.
      </div>

      {
        (canDownloadAsset && downloadLink !== null) &&
          <Fragment>
            In the meantime you can
            <button
              className="download-link"
              title={displayFilename}
              onClick={onDownloadClick}
            >
              {' download ' /* spaces in React are annoying */}
            </button>
            the file.
          </Fragment>
      }

    </div>
  </div>
);

const PresentationProcessing = (props)=> (
  <SiteViewerVersionComponentSelector>
    <PresentationProcessing_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <PresentationProcessing_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

PresentationProcessing.propTypes = {
  downloadLink: PropTypes.string,
  displayFilename: PropTypes.string.isRequired,
  canDownloadAsset: PropTypes.bool.isRequired,
  onDownloadClick: PropTypes.func.isRequired
};

export default PresentationProcessing;
